import { AdjacentType, BranchingQueryDefinition, DataModelNodeEdgeMapper, getItemTypeToGroupNestedDescendingQueryDef, getParentEdgeTypeId, getSimpleBranchingQuery, getSimpleSubjectQuery, } from '@iotv/datamodel';
const debug = process.env.REACT_APP_DEBUG && true;
let x = true;
/** A catch all query generator that will get all of provided type beneath a customer. Note that it may return other types based on the query e.g. getting all Areas also gets all Properties, because they're necessary.
 * @param type - The type to fetch
 * @param supportedType - if type is 'Group', then supportedType can filter the query to only groups with that supportedType
 * */
const getQueryForType = (type) => {
    switch (type) {
        case 'Property': {
            return new BranchingQueryDefinition({
                id: 'custToProperty',
                path: [{ objectTypeId: 'Property', adjacencyType: AdjacentType.CHILD, edgeTypeId: getParentEdgeTypeId('Property', 'Customer') }],
                subQueries: [],
            });
        }
        case 'Place':
        case 'Area': {
            const areaPlace = getSimpleBranchingQuery('Area', 'Place', AdjacentType.CHILD);
            const areaArea = getSimpleBranchingQuery('Area', 'Area', AdjacentType.CHILD);
            areaArea.addSubQuery(areaArea);
            areaArea.addSubQuery(areaPlace);
            const propArea = getSimpleBranchingQuery('Property', 'Area', AdjacentType.CHILD);
            propArea.addSubQuery(areaArea);
            propArea.addSubQuery(areaPlace);
            const custProperty = getSimpleBranchingQuery('Customer', 'Property', AdjacentType.CHILD);
            custProperty.addSubQuery(propArea);
            const custApex = getSimpleSubjectQuery('Customer');
            custApex.addSubQuery(custProperty);
            return custApex;
        }
        // This will get ALL groups under the customer. I don't know when you would want to do that.
        case 'Group':
            {
                console.error('You have done something that no one is allowed to do!');
                //return new BranchingQueryDefinition({
                //  id: 'custToGroup',
                //  path: [{
                //  })
            }
            break;
        default: {
            if (
            //  x
            type === 'ScoreConfig' || DataModelNodeEdgeMapper.isValidEdgeTypeForNodeTypes({
                sourceNodeTypeId: type,
                edgeParams: { objectTypeId: 'Group', adjacencyType: AdjacentType.PARENT },
            })) {
                debug &&
                    console.log(`getQueryForType ${type} is a supported type for Group, so returning letting the UI code return a query from getItemTypeToGroupNestedDescendingQueryDef`);
                return getItemTypeToGroupNestedDescendingQueryDef({
                    groupDefiningObjectTypeId: 'Customer',
                    supportedTypeSubQueries: [],
                    supportedType: type,
                    includeSupportedTypeInstances: true,
                });
            }
            else {
                const bqds = DataModelNodeEdgeMapper.getBranchingQueryDefinitionsForNodeTypes({
                    sourceNodeTypeId: 'Customer',
                    targetNodeTypeId: type,
                    direction: AdjacentType.CHILD,
                    reverseLookup: true,
                    maxPathLength: 5
                });
                // const bqds: BranchingQueryDefinition[] = []
                debug && console.log(`getQueryForType ${type} is not a supported type for Group,  generated ${bqds.length} branching query definitions`, bqds);
                const res = bqds.length > 0
                    ? new BranchingQueryDefinition({ id: 'xPathApex', path: [{ objectTypeId: 'Customer', adjacencyType: AdjacentType.SUBJECT }], subQueries: bqds })
                    : undefined;
                debug && console.log(`getQueryForType ${type} returning bqds with ${res?.subQueries.length} subQueries`, res);
                return res;
            }
        }
    }
};
export const getAllBeneathCustomerQuery = (types) => {
    const queries = types.reduce((curQueries, getBeneathType) => {
        if (typeof getBeneathType == 'string') {
            curQueries.push(getQueryForType(getBeneathType));
        }
        else if (typeof getBeneathType == 'object' && getBeneathType.type == 'Group') {
            curQueries.push(getItemTypeToGroupNestedDescendingQueryDef({
                groupDefiningObjectTypeId: 'Customer',
                supportedTypeSubQueries: [],
                supportedType: getBeneathType.supportedType,
                includeSupportedTypeInstances: false,
            }));
        }
        return curQueries;
    }, []);
    //console.log('Queries to get move targets', queries)
    return new BranchingQueryDefinition({
        id: 'apexQuery',
        path: [{ objectTypeId: 'Customer', adjacencyType: AdjacentType.SUBJECT }],
        subQueries: queries,
    });
};
